import PropTypes from "prop-types";
import { Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { MdOutlineCheck, MdAdd, MdClose } from "react-icons/md";
import { StyledTableToobar, ToolbarBox } from "./Table.style";
import { StyledLink } from "../Link";

const EnhancedTableToolbar = (props) => {
  const { numSelected, tableBtn } = props;

  return (
    <StyledTableToobar
      $numSelected={numSelected > 0}
      style={{ overflowX: "auto" }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} مورد انتخاب شد
        </Typography>
      ) : (
        <ToolbarBox id="tableTitle">
          <Typography
            sx={{ flex: "1 1 100%" }}
            variant="h6"
            color="secondary.dark"
          >
            {props.title}
          </Typography>
        </ToolbarBox>
      )}

      {numSelected > 0 ? (
        <>
          {props.onDelete && (
            <Tooltip title="لغو" arrow>
              <IconButton onClick={props.onDelete}>
                <MdClose />
              </IconButton>
            </Tooltip>
          )}
          {props.onSubmit && (
            <Tooltip title="تایید" arrow>
              <IconButton onClick={props.onSubmit}>
                <MdOutlineCheck />
              </IconButton>
            </Tooltip>
          )}
        </>
      ) : null}
      {tableBtn.length
        ? tableBtn.map((item, index) => (
            <StyledLink key={"table_btn" + index} to={item.route}>
              <Button
                endIcon={
                  item.icon ? item.icon : item.icon === false ? " " : <MdAdd />
                }
                variant={item.type ? item.type : "contained"}
                sx={{ mx: 0.5 }}
              >
                {item?.title || "افزودن"}
              </Button>
            </StyledLink>
          ))
        : ""}
    </StyledTableToobar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  factorInfo: PropTypes.object,
};

export default EnhancedTableToolbar;
